import React from "react";
import { useTranslation } from "react-i18next";
import classes from "./OqishniKochirish.module.css";

const OqishniKochirish = () => {
  const { t } = useTranslation();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.content}>
          <h1 className={classes.title}>
            {t("transfer_rules_title")}
          </h1>
          
          <div className={classes.section}>
            <div className={classes.rulesList}>
              <div className={classes.rule}>
                <span className={classes.ruleNumber}>1.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_1")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>2.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_2")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>3.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_3")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>4.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_4")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>5.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_5")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>5.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_5_alt")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>6.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_6")}
                </span>
                <ul className={classes.rejectionList}>
                  <li>{t("transfer_rejection_1")}</li>
                  <li>{t("transfer_rejection_2")}</li>
                  <li>{t("transfer_rejection_3")}</li>
                  <li>{t("transfer_rejection_4")}</li>
                  <li>{t("transfer_rejection_5")}</li>
                  <li>{t("transfer_rejection_6")}</li>
                  <li>{t("transfer_rejection_7")}</li>
                  <li>{t("transfer_rejection_8")}</li>
                  <li>{t("transfer_rejection_9")}</li>
                </ul>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>7.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_7")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>8.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_8")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>9.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_9")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>10.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_10")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>11.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_11")}
                </span>
              </div>

              <div className={classes.rule}>
                <span className={classes.ruleNumber}>12.</span>
                <span className={classes.ruleText}>
                  {t("transfer_rule_12")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OqishniKochirish; 